import {
  Button,
  Dialog,
  RichTextEditor,
  Stack
} from "@compass/core";
import { Comment } from "generated/openApi";
import produce from "immer";

export const CommentsEditor = (props: {
  editingComment: Comment | undefined;
  setEditingComment: (value: React.SetStateAction<Comment | undefined>) => void;
  handleSend: () => void;
}) => {
  if (props.editingComment === undefined) return null;

  return (
    <Dialog
      open={true}
      maxWidth="lg"
      header={<>Note</>}
      content={
        <RichTextEditor
          value={props.editingComment!.message}
          onChange={(value) =>
            props.setEditingComment(
            produce(props.editingComment, (draft) => {
                draft!.message = value!;
              })
            )
          }
        />
      }
      footer={
        <Stack direction="row" spacing="sm">
          <Button onClick={() => props.setEditingComment(undefined)}>Cancel</Button>
          <Button variant="contained" onClick={props.handleSend} disabled={!props.editingComment.message}>
            Save
          </Button>
        </Stack>
      }
    />
  );
};
